"use client";

import { useState, useEffect } from "react";
import Wallpaper from "./Wallpaper";
import MenuBar from "./MenuBar";
import Dock from "./Dock";
import FolderIcon from "../Icons/FolderIcon";
import TrashIcon from "../Icons/TrashIcon";
import DocumentIcon from "../Icons/DocumentIcon";
import Window from "../Windows/Window";
import StickyNote from "../Windows/StickyNote";
import { project_desk } from "../../data/projects";
import AboutWindows from "../Windows/AboutWindows";
import ImageViewer from "../Windows/ImageViewer";
import "../../../index.css";
import PreLoad from "../Preload/PreLoad";
import useGithubProjects from "../../../hooks/useGithubProjects";
import DocViewer from "../Windows/DocViewer";


export default function Desktop({ closeMac }) {
  const [openWindow, setOpenWindow] = useState(false);
  const [selectedPanel, setSelectedPanel] = useState(null);
  const [openImageViewer, setOpenImageViewer] = useState(null);
  const [openDocViewer, setOpenDocViewer] = useState(null);
  const [windowSize, setWindowSize] = useState({ width: 1200, height: 800 });
  const [showPreloader, setShowPreloader] = useState(true);
  const { projects, loading } = useGithubProjects('badu01', true)
  const [selectedProject, setSelectedProject] = useState(null);
  const [isSubPanelOpen, setIsSubPanelOpen] = useState(false);
  const [title, setTitle] = useState(null);
  

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };



    handleResize();
    window.addEventListener("resize", handleResize);


    return () => {
      window.removeEventListener("resize", handleResize);
      
    };
  }, []);


  const handleProjectClick = (project) => {
    console.log(project);
    
    if (project.link && project.link !== "#") {
      window.open(project.link, "_blank", "noopener,noreferrer");
    } else {
      setOpenWindow(true);
      setIsSubPanelOpen(true);
      setSelectedProject(project);
      setTitle(project.name)
      setSelectedPanel("All projects");
    }
  };

  const handleFlolderClick = (name) => {
    setOpenWindow(true);
    if (name === "About Me") {
      setSelectedPanel("about-me");
    } else if (name === "Projects") {
      setIsSubPanelOpen(false);
      setTitle("All projects")
      setSelectedPanel("All projects");
    }
  }

  const handleImageClick = (src) => {
    setOpenImageViewer(src);
  };

  const handleDocClick = (data) =>{
    setOpenDocViewer(data);
  }
  
  return (
    <>
      {
        showPreloader ? <PreLoad isLoading={loading} setShowPreloader={setShowPreloader}/> :

          <div
            className="relative w-screen h-screen overflow-hidden select-none"
            style={{ backgroundColor: "#f7f7f7" }}
          >
            {/* Wallpaper / Grid background */}
            <Wallpaper />

            {/* Welcome text in center */}
            {/* <WelcomeText /> */}

            {/* Menu Bar */}
            <MenuBar closeMac={closeMac} />

            {/* Desktop icons - Project folders */}
            {project_desk.map((project,index) => (
              <FolderIcon
                key={projects[index].name}
                name={projects[index].name}
                onClick={() => handleProjectClick(projects[index])}
                style={{
                  position: "absolute",
                  top: project.position.top,
                  right: project.position.right,
                }}
              />
            ))}

            {/* About Me document icon */}
            <FolderIcon
              name="About Me"
              onClick={() => handleFlolderClick("About Me")}
              style={{
                position: "absolute",
                top: 105,
                left: 405,
              }}
            />
            <FolderIcon
              name="All projects"
              onClick={() => handleFlolderClick("Projects")}
              style={{
                position: "absolute",
                top: 105,
                right: 405,
              }}
            />
            {/* Resume document icon */}
            <DocumentIcon
              name="Resume"
              src="./resume_icon.png"
              onClick={()=>setOpenDocViewer({src:'./resume.md',name:'Resume'})}
              style={{
                position: "absolute",
                top: 115,
                left: 571,
              }}
            />

            {/* Trash icon */}
            <TrashIcon
              style={{
                position: "absolute",
                top: 100,
                left: 750,
              }}
            />

            {/* Sticky Note - About Me */}
            <StickyNote
              title="Hi I'm"
              content={`Badusha Pareed`}
              width={309}
              height={205}
            />

            {/* Dock */}
            <Dock setOpenWindow={setOpenWindow} setSelectedPanel={setSelectedPanel} setIsSubPanelOpen={setIsSubPanelOpen}/>

            {openWindow && selectedPanel !== "about-me" && (
              <Window
                onClose={() => setOpenWindow(false)}
                initialPosition={{
                  x: windowSize.width / 2 - 418,
                  y: windowSize.height / 2 - 203,
                }}
                panelType={selectedPanel}
                setPanelType={setSelectedPanel}
                imageClick={handleImageClick}
                docClick = {handleDocClick}
                setSelectedProject={setSelectedProject}
                selectedProject={selectedProject}
                setIsSubPanelOpen={setIsSubPanelOpen}
                isSubPanelOpen={isSubPanelOpen}
                title={title}
                setTitle={setTitle}
              >
              </Window>
            )}

            {/* Open Window for About Me */}
            {openWindow && selectedPanel === "about-me" && (
              <AboutWindows
                onClose={() => setOpenWindow(false)}
              />
            )}
            {
              openImageViewer && (
                <ImageViewer
                  title={openImageViewer.title}
                  imgSource={openImageViewer.src}
                  initialPosition={{
                    x: windowSize.width / 2 - 400,
                    y: windowSize.height / 2 - 300,
                  }}
                  onClose={() => setOpenImageViewer(null)}
                />
              )
            }

            {openDocViewer && (
              <DocViewer
                  name={openDocViewer.name}
                  owner={openDocViewer.owner}
                  src = {openDocViewer.src || null}
                  initialPosition={{
                    x: windowSize.width / 2 - 20,
                    y: windowSize.height / 2 - 350,
                  }}
                  onClose={() => setOpenDocViewer(null)}
              />
            )}
          </div>
      }
    </>
  );
}
